import { render, staticRenderFns } from "./ProduksiListrik.vue?vue&type=template&id=a144849c&"
import script from "./ProduksiListrik.vue?vue&type=script&lang=js&"
export * from "./ProduksiListrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports